export default __webpack_public_path__ + "static/media/metatrader.a32f363b.svg";